import confirmTemplate from '@/plugins/confirm/ConfirmTemplate.vue'
import vuetify from '@/plugins/vuetify'

/* eslint-disable prefer-promise-reject-errors */
export default {
  install(Vue) {
    let ConfirmConstructor = Vue.extend(confirmTemplate)
    let confirmInstance = null
    Vue.prototype.$confirm = config => {
      return new Promise(resolve => {
        if (confirmInstance) return
        confirmInstance = new ConfirmConstructor({
          el: document.createElement('div'),
          vuetify
        })

        // Set data properties
        confirmInstance.title = config.title || ''
        confirmInstance.message = config.message || ''
        confirmInstance.underText = config.underText || ''
        confirmInstance.confirmText = config.confirmText || 'Sair'
        confirmInstance.cancelText = config.cancelText || 'Cancelar'
        confirmInstance.confirmColor = config.confirmColor || 'error'
        confirmInstance.confirmFontColor = config.confirmFontColor || '#ffffff'
        confirmInstance.cancelColor = config.cancelColor || 'grey'
        confirmInstance.icon = config.icon || false
        confirmInstance.showCancelButton = config.showCancelButton || false

        // Override methods
        confirmInstance.onConfirm = () => {
          confirmInstance.open = false
          document.body.removeChild(confirmInstance.$el)
          confirmInstance.$destroy()
          confirmInstance = null
          resolve(true)
        }
        confirmInstance.onCancel = () => {
          confirmInstance.open = false
          document.body.removeChild(confirmInstance.$el)
          confirmInstance.$destroy()
          confirmInstance = null
          resolve(false)
        }

        confirmInstance.open = true
        document.body.appendChild(confirmInstance.$el)
      })
    }
  }
}
